// Screen 7 (Lead view) · Department Status — read-only, neutral, Tier-1 only.
// "Who has planned what this week", NEVER a ranking or a quality call. Late = quiet.

import { api } from "../api";
import { esc } from "../dom";

interface StatusRow {
  teacher_name: string;
  class_name: string;
  week_no: number;
  status: "not_started" | "in_progress" | "submitted" | "approved";
  on_time: boolean | null;
  submitted_at: string | null;
  plan_id: string | null;
}

function statusChip(row: StatusRow): string {
  // Approved is a calm coordination fact (the "approved by HOD" loop made visible) — never a trophy.
  if (row.status === "approved") {
    return `<span class="chip approved">Approved ✓</span>`;
  }
  if (row.status === "submitted") {
    // No loud "LATE" — a late submission just shows its quiet time.
    const note = row.on_time === false ? ` <span class="muted">(submitted late)</span>` : "";
    return `<span class="chip submitted">Submitted</span>${note}`;
  }
  return `<span class="chip">Draft</span>`;
}

export async function renderLeadStatus(app: HTMLElement): Promise<void> {
  const { rows } = await api<{ rows: StatusRow[] }>("/api/lead/status");

  const body = rows.length
    ? rows
        .map((r) => {
          // The Lead may open plan content (teacher+Lead tier, spec §5) when a plan exists.
          const inner = `<strong>${esc(r.teacher_name)}</strong> · ${esc(r.class_name)} · Week ${esc(
            r.week_no,
          )}<div style="margin-top:6px">${statusChip(r)}</div>`;
          return r.plan_id
            ? `<a class="card" data-link href="/plan/${esc(r.plan_id)}">${inner}</a>`
            : `<div class="card">${inner}</div>`;
        })
        .join("")
    : `<p class="empty">No plans yet this term.</p>`;

  app.innerHTML = `
    <div class="topbar"><a data-link href="/" class="muted">← Home</a></div>
    <h1>Department Status</h1>
    <p class="hint">Who has planned what. Coordination, not a scoreboard.</p>
    ${body}`;
}
